import React, { useState, useEffect } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import DownloadIcon from '@mui/icons-material/Download';
import {
  Container,
  Typography,
  Grid,
  Card,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  styled,
  createTheme,
  ThemeProvider,
  Box,
  CardMedia,
  Button,
} from '@mui/material';
import moment from 'moment';

const statistiquesCommunicationData = [
  
  {
    ministere: 'Ministère de la Communication, des Technologies de l’Information et des Médias',
    annuaires: 'RAPPORT DES INDICATETEURS TIC AU BURUNDI, EDITION 2024',
    description: 'Un rapport détaillé sur les indicateurs clés du secteur des technologies de l’information et de la communication au Burundi, offrant une analyse approfondie des tendances et des performances du secteur pour l’année 2024.',
    date: "2024-12-31",
    link: "/documents/Sectorials/RAPPORT_DES_INDICATEURS_TIC_EDITION_2024.pdf"
  },
  {
    ministere: 'Ministère de la Communication, des Technologies de l’Information et des Médias',
    annuaires: 'ANNUAIRE DES STATISTIQUES ÉDITION 2021',
    description: 'Les statistiques essentielles sur l’évolution du secteur des technologies de l’information et des médias, mettant en évidence les avancées et les défis rencontrés durant l’année 2021.',
    date: "2021-12-31",
    link: "/documents/Sectorials/Annuaire-Statistique-du-Secteur-des-TIC-et-des-Postes-publie-en-2019.pdf"
  },
  {
    ministere: 'Ministère de la Communication, des Technologies de l\'Information et des Médias',
    annuaires: 'ANNUAIRE DES STATISTIQUES ÉDITION 2019',
    description: 'Une vue d’ensemble des performances des médias et des technologies de l’information, ce rapport donne un aperçu des statistiques clés pour l’année 2019.',
    date: "2019-12-31",
    link: "/documents/Sectorials/Annuaire-statistique-2019-1.pdf" 
  },
];

function MinistereCommunication() {
  const [visibleCount, setVisibleCount] = useState(4); 
  const [selectedYear, setSelectedYear] = useState('Tous');
  const [filteredStatistiques, setFilteredStatistiques] = useState([]);

  useEffect(() => {
    const sortedData = statistiquesCommunicationData.sort((a, b) => new Date(b.date) - new Date(a.date));
    setFilteredStatistiques(sortedData);
  }, []);

  const handleShowMore = () => {
    setVisibleCount((prevCount) => Math.min(prevCount + 1, filteredStatistiques.length)); 
  };

  const handleYearChange = (event) => {
    const year = event.target.value;
    setSelectedYear(year);
    if (year === 'Tous') {
      setFilteredStatistiques(statistiquesCommunicationData.sort((a, b) => new Date(b.date) - new Date(a.date)));
    } else {
      const filtered = statistiquesCommunicationData.filter((statistique) => {
        const statistiqueYear = new Date(statistique.date).getFullYear();
        return statistiqueYear === parseInt(year);
      });
      setFilteredStatistiques(filtered.sort((a, b) => new Date(b.date) - new Date(a.date)));
    }
  };

  const StyledSelect = styled(Select)(({ theme }) => ({
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.light,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.dark,
    },
  }));

  const theme = createTheme({
    palette: {
      primary: {
        main: '#388E3C',
      },
      background: {
        default: '#f5f5f5',
      },
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      body1: {
        fontSize: 16,
        letterSpacing: 0.5,
        color: '#6B778C',
      },
      h4: {
        fontWeight: '600',
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div style={{ backgroundColor: theme.palette.background.default, paddingBottom: '32px' }}>
        <NavigationBar />
        <Container maxWidth="lg" style={{ paddingTop: '54px' }}>
          <Typography variant="h4" align="justify" gutterBottom style={{ color: theme.palette.primary.main, marginBottom: '16px' }}>
            Ministère de la Communication et des Médias
          </Typography>
          <Divider style={{ margin: '16px 0' }} />
          <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px' }}>
            Le Ministère de la Communication, des Technologies de l’Information et des Médias joue un rôle crucial dans le développement des infrastructures de communication et des technologies numériques. Cette page fournit un aperçu des statistiques importantes concernant le secteur des TIC et des médias.
          </Typography>

          <FormControl fullWidth variant="outlined" style={{ marginLeft: '0px', width: '300px' }}>
            <InputLabel id="year-select-label"> Filtrer par année de réalisation </InputLabel>
            <StyledSelect
              labelId="year-select-label"
              id="year-select"
              value={selectedYear}
              onChange={handleYearChange}
              label=" Filtrer par année de réalisation"
            >
              <MenuItem value="Tous">Tous les annuaires</MenuItem>
              {[...new Set(statistiquesCommunicationData.map((statistique) => new Date(statistique.date).getFullYear()))]
                .sort((a, b) => b - a) 
                .map((year) => (
                  <MenuItem key={year} value={year.toString()}>
                    {year}
                  </MenuItem>
                ))}
            </StyledSelect>
          </FormControl>

          <Grid container spacing={1} style={{ marginTop: '5px' }}>
            {filteredStatistiques.slice(0, visibleCount).map((statistique, index) => (
              <Grid item xs={12} sm={12} key={index}>
                <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden' }}>
                  <Box sx={{ display: 'flex' }}>
                    <a
                      href={statistique.link}
                      style={{ textDecoration: 'none', color: 'inherit' }}
                       target="_blank"
                      rel="noopener noreferrer"
                    >
                      <CardMedia
                        component="img"
                        sx={{ width: 71, height: 100, m: 2 }}
                        image={"assets/annuaires/minicommunication.png"} 
                        alt={statistique.annuaires}
                      />
                    </a>
                    <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                      <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px', color: theme.palette.primary.main }}>
                        <a
                          href={statistique.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ textDecoration: 'none', color: 'inherit' }}
                        >
                          {<DownloadIcon />}{statistique.annuaires}
                        </a>
                      </Typography>
                      <Typography variant="body2" component="div" style={{ color: '#555', marginBottom: '10px' }}>
                        {statistique.description}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        Publié en {moment(statistique.date).format('MMMM YYYY')}
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>

          {visibleCount < filteredStatistiques.length && (
            <Button
              onClick={handleShowMore}
              style={{
                marginTop: '20px',
                backgroundColor: theme.palette.primary.main,
                color: 'white',
              }}
            >
              Plus de Statistiques
            </Button>
          )}
        </Container>
        <br />
        <br />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default MinistereCommunication;